import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { PageTitle } from 'presentation/components/PageTitle';
import FormSimulateSale from './components/FormSimulateSale';

type props = {
    simualteUseCase: SimulateUseCaseInterface;
};

const CU01001Page = ({ simualteUseCase }: props) => {
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-010-01-container"
        >
            <PageTitle title="売却シミュレーション" />
            <FormSimulateSale />
        </div>
    );
};

export default CU01001Page;
